import type {ReactElement} from 'react';
import React from 'react';
import {GA4EventParamName} from '@Libraries/ga-events';
import {AJAXResponseProductData, ANALYTICS_ACTION_FOR_SIGNAGE} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import {DigitalSignageOption} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/publishing-digital-signage-list.types';
import type {PublishingSignageLivePanelProps} from './publishing-signage-live-panel.types';
import styles from './publishing-signage-live-panel.module.scss';
import {useAppSelector} from '@/hooks';
import type {RootState} from '@/store';
import {DigitalSignageSubPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/digital-signage-sub-panel/digital-signage-sub-panel';
import {usePosterProduct, usePrintProduct} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.hooks';

export function PublishingSignageLivePanel({...props}: PublishingSignageLivePanelProps): ReactElement {
  window.PMW.gtm.trackGA4CustomEvent(ANALYTICS_ACTION_FOR_SIGNAGE, {[GA4EventParamName.TYPE]: 'SignageLive'});
  const premiumProductDataForPoster = usePosterProduct();
  const premiumProductDataForPrint = usePrintProduct();

  const productUsed: AJAXResponseProductData | undefined =
    premiumProductDataForPoster && Object.keys(premiumProductDataForPoster).length > 0 ? premiumProductDataForPoster : premiumProductDataForPrint;

  const onDownloadSignageWidget = (): void => {
    void window.PMW.writeLocal('cart/addOrderUsedByDigitalSignage', {
      orderId: productUsed?.orderId,
      type: DigitalSignageOption.SIGNAGE_LIVE,
    });
    window.location.href = window.PMW.util.site_url(`cart/prepSignageLiveWidgetDownload?id=${productUsed?.orderId}&t=${new Date().getTime()}`);
  };

  return (
    <DigitalSignageSubPanel
      panelHeading={window.i18next.t('pmwjs_signagelive')}
      heading={window.i18next.t('pmwjs_signagelive_widget')}
      subheading={window.i18next.t('pmwjs_signagelive_desc')}
      showButton
      onClose={props.onClose}
      buttonText={window.i18next.t('pmwjs_download_widget')}
      onClick={onDownloadSignageWidget}
      imgSrc="publishing-signagelive.png"
    />
  );
}
